var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
export function RequestProof(_a) {
    var data = _a.data;
    var acompanharProcesso = function () {
        var portalUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";
        var url = "".concat(portalUrl, "/app/app-detran-habilitacao/consultar-processo-da-carteira-nacional-de-habilitacao-(cnh)/informacao");
        window.open(url, "acompanhamento-processo");
    };
    return (_jsxs(_Fragment, { children: [_jsx("h6", __assign({ className: "font-semibold text-2xl text-center" }, { children: "Comprovante de Solicita\u00E7\u00E3o" })), _jsxs("div", __assign({ className: "text-xl flex flex-col h-full gap-6" }, { children: [_jsxs("div", __assign({ className: "flex gap-5" }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: "Protocolo:" })), _jsx("span", __assign({ className: "justify-self-end self-end font-light" }, { children: data.protocol }))] })), _jsxs("div", __assign({ className: "flex gap-8" }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: "Situa\u00E7\u00E3o:" })), _jsx("span", __assign({ className: "justify-self-end self-end font-light" }, { children: "Aguardando pagamento" }))] }))] })), _jsx("div", __assign({ className: "w-full flex justify-end" }, { children: _jsx(Button, __assign({ variant: "outline", onClick: acompanharProcesso }, { children: "Acompanhar protocolo" })) }))] }));
}
